/* hfb.js — Metal Powders USA bespoke behaviour. Dependency-free, progressive:
 * every form works as a plain Shopify contact form without this file.
 *  1. Bulk quote form: "Add another metal" repeat rows (names stay unique so each
 *     row arrives as its own line in the store notification email).
 *  2. Pointer spotlight on .hfb-spot cards (Magic UI magic-card technique: a radial
 *     gradient positioned from pointer coordinates written to CSS vars).
 *  3. Analytics hooks: dispatches size-ladder / quote / document events on window for
 *     the store's Customer Events pixel (conversion.md §3). No PII in payloads. */
(function () {
  'use strict';

  function initMetalRows(root) {
    var list = root.querySelector('[data-hfb-metal-rows]');
    var tpl = root.querySelector('template[data-hfb-metal-row]');
    var add = root.querySelector('[data-hfb-add-metal]');
    if (!list || !tpl || !add) return;
    var max = parseInt(list.getAttribute('data-max') || '6', 10);
    function renumber() {
      var rows = list.querySelectorAll('[data-hfb-metal-row-item]');
      rows.forEach(function (row, i) {
        var n = i + 1;
        row.querySelectorAll('[data-name]').forEach(function (el) {
          var base = el.getAttribute('data-name');
          el.name = 'contact[' + base + (n > 1 ? ' ' + n : '') + ']';
          var id = el.getAttribute('data-id-base') + '-' + n;
          var label = row.querySelector('label[data-for="' + el.getAttribute('data-id-base') + '"]');
          el.id = id;
          if (label) label.htmlFor = id;
        });
        var rm = row.querySelector('[data-hfb-remove-metal]');
        if (rm) rm.hidden = rows.length < 2;
      });
      add.hidden = rows.length >= max;
    }
    add.addEventListener('click', function () {
      var frag = tpl.content.cloneNode(true);
      list.appendChild(frag);
      renumber();
      var rows = list.querySelectorAll('[data-hfb-metal-row-item]');
      var sel = rows[rows.length - 1].querySelector('select');
      if (sel) sel.focus();
    });
    list.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hfb-remove-metal]');
      if (!btn) return;
      var row = btn.closest('[data-hfb-metal-row-item]');
      if (row) row.remove();
      renumber();
      add.focus();
    });
    renumber();
  }

  function initSpot() {
    if (window.matchMedia('(hover: none)').matches) return;
    document.addEventListener('pointermove', function (e) {
      var el = e.target.closest && e.target.closest('.hfb-spot');
      if (!el) return;
      var r = el.getBoundingClientRect();
      el.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      el.style.setProperty('--my', (e.clientY - r.top) + 'px');
    }, { passive: true });
  }

  function emit(name, detail) {
    try { window.dispatchEvent(new CustomEvent('hfb:' + name, { detail: detail })); } catch (err) { /* old browser: no-op */ }
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try { window.Shopify.analytics.publish(name, detail); } catch (err) { /* pixel not ready */ }
    }
  }

  function initEvents() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-hfb-event]');
      if (!a) return;
      var detail = {};
      Array.prototype.forEach.call(a.attributes, function (at) {
        if (at.name.indexOf('data-hfb-') === 0 && at.name !== 'data-hfb-event') detail[at.name.slice(9)] = at.value;
      });
      emit(a.getAttribute('data-hfb-event'), detail);
    });
    document.querySelectorAll('form[data-hfb-quote]').forEach(function (f) {
      f.addEventListener('submit', function () {
        var metal = f.querySelector('[name^="contact[Metal"], [name="contact[Product]"]');
        emit('generate_lead', { source: f.getAttribute('data-hfb-quote'), metal: metal ? metal.value : '' });
      });
    });
  }

  /* ---- Edit 12237 -------------------------------------------------------------
   * 4. Gallery lightbox ([data-hfb-lightbox]): one <dialog>, prev / next, arrow keys,
   *    swipe, Escape (native), focus returns to the photo that opened it.
   * 5. Smooth <details>: height animation on open AND close (accordions, bulk line).
   * 6. Metal marquee ([data-hfb-marquee]): loops, pauses on hover / focus, drag to scrub.
   * 7. Scroll drift ([data-hfb-drift]): the photo starts low and eases up as you scroll.
   * 8. Count-up ([data-hfb-count]): the leading number counts from zero when its row
   *    reveals. It rides the ONE reveal observer (hfb-motion.js) by watching for its
   *    is-revealed class, so this file never adds a second reveal mechanism. */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function still() { return reduceMotion.matches; }
  var ICON = {
    prev: '<svg viewBox="0 -960 960 960" aria-hidden="true" fill="currentColor"><path d="M566-232 318-480l248-248 37 37-211 211 211 211-37 37Z"/></svg>',
    next: '<svg viewBox="0 -960 960 960" aria-hidden="true" fill="currentColor"><path d="M394-232 357-269l211-211-211-211 37-37 248 248-248 248Z"/></svg>',
    close: '<svg viewBox="0 -960 960 960" aria-hidden="true" fill="currentColor"><path d="m252-215-37-37 228-228-228-228 37-37 228 228 228-228 37 37-228 228 228 228-37 37-228-228-228 228Z"/></svg>'
  };

  function initLightbox() {
    var hosts = document.querySelectorAll('[data-hfb-lightbox]');
    if (!hosts.length || typeof HTMLDialogElement !== 'function') return;
    var dlg = document.createElement('dialog');
    dlg.className = 'hfb-lb';
    dlg.setAttribute('aria-label', 'Image viewer');
    dlg.innerHTML =
      '<div class="hfb-lb__bar"><span class="hfb-lb__count" aria-live="polite"></span>' +
      '<button type="button" class="hfb-lb__btn" data-lb="close" aria-label="Close">' + ICON.close + '</button></div>' +
      '<div class="hfb-lb__stage">' +
      '<button type="button" class="hfb-lb__btn hfb-lb__nav hfb-lb__nav--prev" data-lb="prev" aria-label="Previous image">' + ICON.prev + '</button>' +
      '<img class="hfb-lb__img" alt="">' +
      '<button type="button" class="hfb-lb__btn hfb-lb__nav hfb-lb__nav--next" data-lb="next" aria-label="Next image">' + ICON.next + '</button>' +
      '</div><p class="hfb-lb__cap"></p>';
    document.body.appendChild(dlg);
    var img = dlg.querySelector('.hfb-lb__img');
    var cap = dlg.querySelector('.hfb-lb__cap');
    var count = dlg.querySelector('.hfb-lb__count');
    var prevBtn = dlg.querySelector('[data-lb="prev"]');
    var nextBtn = dlg.querySelector('[data-lb="next"]');
    var items = [], index = 0, opener = null;

    function show(i, instant) {
      index = (i + items.length) % items.length;
      var t = items[index];
      function swap() {
        img.src = t.getAttribute('data-hfb-lb-src');
        img.alt = t.getAttribute('data-hfb-lb-alt') || '';
        if (t.getAttribute('data-hfb-lb-w')) { img.width = +t.getAttribute('data-hfb-lb-w'); img.height = +t.getAttribute('data-hfb-lb-h'); }
        cap.textContent = t.getAttribute('data-hfb-lb-caption') || '';
        count.textContent = (index + 1) + ' / ' + items.length;
        img.classList.remove('is-swapping');
      }
      if (instant || still()) return swap();
      img.classList.add('is-swapping');
      setTimeout(swap, 220);
    }
    function open(trigger) {
      items = Array.prototype.slice.call(trigger.closest('[data-hfb-lightbox]').querySelectorAll('[data-hfb-lb-src]'));
      opener = trigger;
      prevBtn.hidden = nextBtn.hidden = items.length < 2;
      show(items.indexOf(trigger), true);
      document.documentElement.classList.add('hfb-lb-lock');
      dlg.showModal();
      dlg.querySelector('[data-lb="close"]').focus();
    }
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('hfb-lb-lock');
      if (opener) opener.focus();
    });
    dlg.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lb]');
      if (b) {
        var a = b.getAttribute('data-lb');
        if (a === 'close') dlg.close(); else show(index + (a === 'next' ? 1 : -1));
        return;
      }
      // a click on the dark surround (not the photo or caption) closes
      if (e.target === dlg || e.target.classList.contains('hfb-lb__stage')) dlg.close();
    });
    dlg.addEventListener('keydown', function (e) {
      if (items.length < 2) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
    });
    var sx = null;
    dlg.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') sx = e.clientX; });
    dlg.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx; sx = null;
      if (Math.abs(dx) > 50 && items.length > 1) show(index + (dx < 0 ? 1 : -1));
    });
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-hfb-lightbox] [data-hfb-lb-src]');
      if (!t) return;
      e.preventDefault();
      open(t);
    });
  }

  function initSmoothDetails() {
    var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
    document.querySelectorAll('details.hfb-acc__item, .hfb-bulkline > details').forEach(function (d) {
      var summary = d.querySelector('summary');
      if (!summary || !d.animate) return;
      var anim = null, closing = false;
      function heightWhen(open) {
        // measured synchronously (no paint in between), so the toggle is never seen
        var was = d.open, h = d.style.height;
        d.style.height = '';
        d.open = open;
        var v = d.offsetHeight;
        d.open = was;
        d.style.height = h;
        return v;
      }
      function finish(open) {
        d.open = open;
        anim = null; closing = false;
        d.classList.remove('is-closing');
        d.style.height = d.style.overflow = '';
      }
      summary.addEventListener('click', function (e) {
        if (still()) return;
        e.preventDefault();
        var start = d.offsetHeight;
        if (anim) anim.cancel();
        d.style.overflow = 'hidden';
        var opening = closing || !d.open;
        var end = heightWhen(opening);
        d.open = true; // content stays rendered while it animates either way
        closing = !opening;
        d.classList.toggle('is-closing', closing);
        anim = d.animate({ height: [start + 'px', end + 'px'] }, { duration: opening ? 520 : 440, easing: EASE });
        anim.onfinish = function () { finish(opening); };
        anim.oncancel = function () { anim = null; };
      });
    });
  }

  function initMarquee() {
    document.querySelectorAll('[data-hfb-marquee]').forEach(function (box) {
      var rail = box.querySelector('.hfb-marquee__rail');
      var track = rail && rail.querySelector('.hfb-marquee__track');
      if (!track || still()) return; // reduced motion / no JS: a plain horizontal scroller
      // enough copies to cover twice the strip, so the loop never shows a gap
      var w = track.scrollWidth;
      if (!w) return;
      var copies = Math.max(1, Math.ceil((box.clientWidth * 2) / w));
      for (var i = 0; i < copies; i++) {
        var c = track.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('a').forEach(function (a) { a.tabIndex = -1; });
        rail.appendChild(c);
      }
      box.classList.add('is-js');
      var x = 0, speed = 38, last = 0, paused = false, drag = null, moved = false;
      function wrap() { w = track.offsetWidth; if (x <= -w) x += w; if (x > 0) x -= w; }
      function frame(t) {
        var dt = last ? Math.min(64, t - last) : 0; last = t;
        if (!paused && !drag) x -= speed * dt / 1000;
        wrap();
        rail.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
      box.addEventListener('mouseenter', function () { paused = true; });
      box.addEventListener('mouseleave', function () { paused = false; });
      box.addEventListener('focusin', function (e) {
        paused = true;
        // keep a keyboard-focused name inside the strip
        var r = e.target.getBoundingClientRect(), b = box.getBoundingClientRect();
        if (r.left < b.left || r.right > b.right) { x += (b.left + b.width / 2) - (r.left + r.width / 2); wrap(); }
      });
      box.addEventListener('focusout', function () { paused = false; });
      box.addEventListener('pointerdown', function (e) {
        if (e.button !== 0) return;
        drag = { sx: e.clientX, x0: x, id: e.pointerId }; moved = false;
      });
      box.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.sx;
        if (!moved && Math.abs(dx) > 5) { moved = true; box.classList.add('is-dragging'); try { box.setPointerCapture(e.pointerId); } catch (err) { /* noop */ } }
        if (moved) { x = drag.x0 + dx; wrap(); }
      });
      function end(e) {
        if (!drag || (e.pointerId !== undefined && e.pointerId !== drag.id)) return;
        drag = null; box.classList.remove('is-dragging');
        if (e.pointerType !== 'mouse') paused = false;
      }
      box.addEventListener('pointerup', end);
      box.addEventListener('pointercancel', end);
      // a drag must not also follow the link it started on
      box.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    });
  }

  function initDrift() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-hfb-drift]'));
    if (!els.length || still()) return;
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight || 1;
      els.forEach(function (el) {
        var host = el.closest('.hfb-sec') || el;
        var r = host.getBoundingClientRect();
        if (r.bottom < -200) return;
        var amount = parseFloat(el.getAttribute('data-hfb-drift')) || 80;
        // 0 as the section's top enters the screen, 1 once it reaches the top: a slow,
        // near-linear rise across a full screen of scrolling
        var p = Math.min(1, Math.max(0, (vh - r.top) / vh));
        var eased = p * (2 - p) * 0.5 + p * 0.5;
        el.style.setProperty('--hfb-drift-y', (amount * (1 - eased)).toFixed(1) + 'px');
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    // capture phase: this theme scrolls inside .page-wrapper, not the window, and scroll
    // events do not bubble — capturing on document hears whichever element scrolls
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-hfb-count]');
    if (!els.length) return;
    els.forEach(function (el) {
      var text = el.textContent.trim();
      var m = /^(\D*)(\d[\d,]*(?:\.\d+)?)([\s\S]*)$/.exec(text);
      if (!m) return;
      var target = parseFloat(m[2].replace(/,/g, ''));
      var commas = m[2].indexOf(',') > -1 || target >= 10000;
      var decimals = (m[2].split('.')[1] || '').length;
      var host = el.closest('.hfb-reveal-stagger, .hfb-reveal');
      var row = el.closest('.hfb-reveal-stagger > *') || el;
      if (still() || !host || !document.documentElement.classList.contains('hfb-motion-ready') || host.classList.contains('is-revealed')) return;
      function fmt(v) {
        var s = v.toFixed(decimals);
        return commas ? Number(s).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) : s;
      }
      // the final value stays in the accessibility tree; the counting copy is visual only
      el.textContent = '';
      var anim = document.createElement('span');
      anim.setAttribute('aria-hidden', 'true');
      anim.textContent = m[1] + fmt(0) + m[3];
      var real = document.createElement('span');
      real.className = 'visually-hidden';
      real.textContent = text;
      el.appendChild(anim); el.appendChild(real);
      function run() {
        var delay = parseFloat(getComputedStyle(row).getPropertyValue('--hfb-reveal-delay')) || 0;
        var dur = 1800, t0 = null;
        setTimeout(function () {
          requestAnimationFrame(function step(t) {
            if (t0 === null) t0 = t;
            var p = Math.min(1, (t - t0) / dur);
            var e = 1 - Math.pow(1 - p, 3);
            anim.textContent = m[1] + fmt(target * e) + m[3];
            if (p < 1) requestAnimationFrame(step); else anim.textContent = text;
          });
        }, delay + 250);
      }
      var mo = new MutationObserver(function () {
        if (host.classList.contains('is-revealed')) { mo.disconnect(); run(); }
      });
      mo.observe(host, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    document.querySelectorAll('[data-hfb-quote-form]').forEach(initMetalRows);
    initSpot();
    initEvents();
    initLightbox();
    initSmoothDetails();
    initMarquee();
    initDrift();
    // hfb-motion.js (also deferred, loaded first) arms the reveal CSS before this runs
    initCountUp();
    // A submitted PDP quote form re-renders server-side with posted_successfully; keep its panel open.
    document.querySelectorAll('details[data-hfb-keep-open]').forEach(function (d) { if (d.querySelector('.hfb-form__success, .hfb-form__error')) d.open = true; });
  });
})();
